var app = angular.module("leonardo");

var CloneTypeDialog = function($scope, FormErrorsService, ClientInstanceService) {
  $scope.element = $scope.ngDialogData.element;
  $scope.alert_message = $scope.ngDialogData.alert_message;
  $scope.onlyClientInstance = $scope.ngDialogData.onlyClientInstance;
  $scope.type = $scope.ngDialogData.type;
  $scope.title = $scope.ngDialogData.title ? $scope.ngDialogData.title : 'Clone ' + $scope.type;
  $scope.type_result = $scope.onlyClientInstance ? 'client_instance' : 'default';
  $scope.clientInstanceService = ClientInstanceService;

  $scope.options = [
    { id: 'default', name: 'Default clone'},
    { id: 'client_instance', name: 'Clone to Client Instance'},
  ];

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var client_instance = $scope.type_result === 'client_instance' ? $scope.client_instance : null;
    $scope.confirm({type_result: $scope.type_result, client_instance: client_instance});
  };
};

app.controller('CloneTypeDialog', ['$scope', 'FormErrorsService', 'ClientInstanceService', CloneTypeDialog]);
